module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAA8CAMAAADsSTwRAAAAXVBMVEUAAAAAAAAAAAAAAAAAAAAODg4ODg4HBwcICAgAAAAAAAAPDw8AAAAAAAAAAAAAAAAAAAAAAAANDQ0AAAAAAAAPDw8AAAAAAAAAAAAAAAAAAAAAAAAODg4QEBAAAACa1dV0AAAAHnRSTlMA3vYh5PvdHhnww79oFAY4+oFfDamZOg7t0tGHXi9GVChMAAAAzElEQVRYw+2V1wqEMBBFNb1pjH3b/P9n7ou6C4KBRLbAnKc8HcKUOwWCIMgnqZzRJAltXLVZAmsgkYaF1eMYEFYmwQgwt2gMkN7TJHxPwCwaDcwXiXgGenkSKGmqhpZATtfIczQjXZFTuqZ59ftyU0WcWklV7zTvzKGLWrrWCtt2Rxq4yuhf7oJzLtr6SBNvm7JcDIJblaeRgg+PgQv5E7/ZahMrcX6n5jClzs1+/PKX4furmR8U+emXn8XjlsX5l+HMO5V/NREEQf6PJ87AKdGjbzugAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rev5.png
// module id = dPfk
// module chunks = 2